import React from 'react'
import { Button } from 'reactstrap'
import './Pages.scss'

const Pages = (props) => {
  return (
    <div>
      <div className={'my-4 text-center'} dangerouslySetInnerHTML={{ __html: props.text }} />
      <div className="d-flex justify-content-center">
        {props.next ? (
          <Button
            color="welcome-page"
            className="text-uppercase font-weight-bold"
            onClick={(e) => props.setScreenState(props.next)}
          >
            Proceed to signature
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export default Pages
